import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalBodyLayout from '../shared/ModalBodyLayout';
import { useSetting } from '../../utilities/sharedHooks/settings';

const CardBlocked = () => {
  const { t: translate } = useTranslation();

  const [supportPhoneNumber, isLoading] = useSetting(
    'server_configurations',
    'support_phone_number'
  );

  return (
    <ModalBodyLayout
      withBack={false}
      renderHeader={() => (
        <div className="flex-row-center w-100">
          <b className="text-f5 text-dark">{translate('activate_card_title')}</b>
        </div>
      )}>
      <div className="mt-4 mb-2">
        <p className="text-f5 text-dark p-0">{translate('card_blocked_note')}</p>
      </div>
      <div className="mt-4">
        <p className="text-f5 text-dark p-0">
          {isLoading ? '' : translate('contact_support_note').replace('%d', supportPhoneNumber)}
        </p>
      </div>
    </ModalBodyLayout>
  );
};

export default CardBlocked;
